export default __webpack_public_path__ + "static/improve-quality-of-life-accomplishment-8a-55790c5ed1738424c23b329a20084aef.webp";